import React from 'react';
import { Search } from 'lucide-react';

const TableOfContents = ({ 
  sections, 
  activeSection, 
  onSectionClick, 
  searchTerm, 
  onSearchChange 
}) => {
  return (
    <div className="bg-white rounded-lg shadow-sm border p-6">
      <h3 className="text-lg font-semibold text-gray-900 mb-4">Table of Contents</h3>
      {/* Search */}
      <div className="relative mb-6">
        <Search className="absolute left-3 top-1/2 transform -translate-y-1/2 text-gray-400" size={16} />
        <input
          type="text"
          placeholder="Search policy..."
          value={searchTerm}
          onChange={(e) => onSearchChange(e?.target?.value)}
          className="w-full pl-9 pr-3 py-2 text-sm border border-gray-300 rounded-md focus:ring-2 focus:ring-blue-500 focus:border-transparent"
        />
      </div>
      {/* Navigation Links */}
      <nav className="space-y-2">
        {sections?.map((section) => {
          const isActive = activeSection === section?.id;
          const matchesSearch = searchTerm === '' || 
            section?.title?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
            section?.content?.toLowerCase()?.includes(searchTerm?.toLowerCase());

          if (!matchesSearch && searchTerm !== '') return null;

          return (
            <button
              key={section?.id}
              onClick={() => onSectionClick(section?.id)}
              className={`
                w-full text-left px-3 py-2 rounded-md text-sm transition-colors
                ${isActive 
                  ? 'bg-blue-100 text-blue-700 font-medium border-l-2 border-blue-500' :'text-gray-600 hover:text-gray-900 hover:bg-gray-50'
                }
                ${matchesSearch && searchTerm ? 'bg-yellow-50' : ''}
              `}
            >
              {section?.title}
            </button>
          );
        })}
      </nav>
      {/* Quick Stats */}
      <div className="mt-6 pt-4 border-t">
        <div className="text-xs text-gray-500 space-y-1">
          <div>Total Sections: {sections?.length || 0}</div>
          {searchTerm && (
            <div>
              Matching: {sections?.filter(section => 
                section?.title?.toLowerCase()?.includes(searchTerm?.toLowerCase()) ||
                section?.content?.toLowerCase()?.includes(searchTerm?.toLowerCase())
              )?.length}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default TableOfContents;